import { createReducer } from "typesafe-actions";

import BoundaryLegend from "@mapmycustomers/shared/types/map/BoundaryLegend";
import { nameComparator } from "@mapmycustomers/shared/util/comparator";

import {
  Actions,
  createBoundaryLegend,
  deleteBoundaryLegend,
  fetchBoundaryLegends,
  updateBoundaryLegend,
} from "./actions";
import BoundaryLegendsState from "./BoundaryLegendsState";

export const boundaryLegendsInitialState: BoundaryLegendsState = {
  creating: false,
  deleting: false,
  legends: [],
  updating: false,
};

// put default legends first, and sort both groups by names
const boundaryLegendComparator = (a: BoundaryLegend, b: BoundaryLegend) => {
  if (a.default && !b.default) {
    return -1;
  } else if (b.default && !a.default) {
    return 1;
  }

  return nameComparator(a, b);
};

const boundaryLegends = createReducer<BoundaryLegendsState, Actions>(boundaryLegendsInitialState)
  .handleAction(fetchBoundaryLegends.success, (state, { payload }) => ({
    ...state,
    legends: payload.toSorted(boundaryLegendComparator),
  }))
  .handleAction(createBoundaryLegend.request, (state) => ({ ...state, creating: true }))
  .handleAction(createBoundaryLegend.success, (state, { payload }) => ({
    ...state,
    creating: false,
    legends: [...state.legends, payload].sort(boundaryLegendComparator),
  }))
  .handleAction(createBoundaryLegend.failure, (state) => ({ ...state, creating: false }))
  .handleAction(updateBoundaryLegend.request, (state) => ({ ...state, updating: true }))
  .handleAction(updateBoundaryLegend.success, (state, { payload }) => ({
    ...state,
    legends: state.legends
      .map((legend) => (legend.id === payload.id ? payload : legend))
      .sort(boundaryLegendComparator),
    updating: false,
  }))
  .handleAction(updateBoundaryLegend.failure, (state) => ({ ...state, updating: false }))
  .handleAction(deleteBoundaryLegend.request, (state) => ({
    ...state,
    deleting: true,
  }))
  .handleAction(deleteBoundaryLegend.success, (state, { payload }) => ({
    ...state,
    deleting: false,
    legends: state.legends.filter(({ id }) => id !== payload),
  }))
  .handleAction(deleteBoundaryLegend.failure, (state) => ({
    ...state,
    deleting: false,
  }));

export * from "./selectors";
export type BoundaryLegendActions = Actions;
export default boundaryLegends;
